const DEBUG_PREFIX = "[AccessDebug]";
const startedAt = Date.now();
let sequence = 0;

const sensitiveKeyPattern = /token|cookie|authorization|password|secret|session.?id/i;

const sanitize = (value, key = "", seen = new WeakSet()) => {
  if (sensitiveKeyPattern.test(key)) {
    return value ? "[present]" : "[absent]";
  }
  if (value instanceof Error) {
    return { name: value.name, message: value.message, stack: value.stack };
  }
  if (Array.isArray(value)) {
    return value.map((item) => sanitize(item, "", seen));
  }
  if (!value || typeof value !== "object") return value;
  if (seen.has(value)) return "[circular]";

  seen.add(value);
  const result = {};
  Object.entries(value).forEach(([childKey, childValue]) => {
    result[childKey] = sanitize(childValue, childKey, seen);
  });
  seen.delete(value);
  return result;
};

const routeSnapshot = () => {
  if (typeof window === "undefined") return {};
  return {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
  };
};

const payload = (details = {}) => ({
  sequence: ++sequence,
  timestamp: new Date().toISOString(),
  elapsedMs: Date.now() - startedAt,
  ...routeSnapshot(),
  ...sanitize(details),
});

export const accessDebug = (scope, message, details = {}) => {
  console.log(`${DEBUG_PREFIX}[${scope}] ${message}`, payload(details));
};

export const accessDebugWarn = (scope, message, details = {}) => {
  console.warn(`${DEBUG_PREFIX}[${scope}] ${message}`, payload(details));
};

export const accessDebugError = (scope, message, error, details = {}) => {
  console.error(
    `${DEBUG_PREFIX}[${scope}] ${message}`,
    payload({ ...details, error }),
  );
};

export const accessDebugTable = (scope, message, rows = []) => {
  accessDebug(scope, message, { rowCount: rows.length });
  console.table(rows.map((row) => sanitize(row)));
};
